// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3euhz","alertIcon":"ConfirmModal_alertIcon__1e6Ow"};